import { WORKPLACE_TYPES } from "@src/appV2/constants/workplaceTypes";

import { useWorkplaceType } from "./useWorkplaceType";

export function useIsHomeHealthWorkplace() {
  const workplaceType = useWorkplaceType();

  return (
    workplaceType === WORKPLACE_TYPES.HOME_HEALTHCARE || workplaceType === WORKPLACE_TYPES.HOSPICE
  );
}
